import { AudioModel } from './../../app/models/audioModel';
import { ConfigHelper } from './../../app/helpers/configHelper';
import { CheckListModel, CheckListListagemModel } from './../../app/models/CheckListModel';
import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';
import { FotoModel } from '../../app/models/fotoModel';
import { VideoModel } from '../../app/models/videoModel';
import { AnexoModel } from '../../app/models/anexoModel';
import { OrcamentoItemModel } from '../../app/models/CardapioModel';
import { VeiculoModel } from '../../app/models/VeiculoModel';

@Injectable()
export class ChecklistProvider {

  constructor(private httpSrv: HttpProvider) {
  }

  async getQuestionarioEntrada(_questionario: number, _modelo: string): Promise<Array<any>> {
    try {
      //console.log('checklist');
      //console.log('questionario/' + questionario + '/' +modelo);
      let ResultConn = await this.httpSrv.getChecklist('questionario/' + _questionario + '/' + _modelo, 0, 'Carregando CheckList Entrada');
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar o questionario do checklist', error);
    }
  }


  async getQuestionarioExtra(_questionario: number, _modelo: string): Promise<Array<any>> {
    try {
      //console.log('checklist');
      //console.log('questionario/' + questionario + '/' +modelo);
      let ResultConn = await this.httpSrv.getChecklist('questionarioextra/' + _questionario + '/' + _modelo, 0, 'Carregando CheckList Extra');
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar o questionario do checklist', error);
    }
  }

  async getQuestionarioMecanico(_questionario: number, _modelo: string): Promise<Array<any>> {
    try {
      //console.log('checklist');
      //console.log('questionario/' + questionario + '/' +modelo);
      let ResultConn = await this.httpSrv.getChecklist('questionariomecanico/' + _questionario + '/' + _modelo, 0, 'Carregando CheckList Mecanicos');
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar o questionariomecanico do checklist', error);
    }
  }

  async getQuestionarioSaida(_questionario: number, _modelo: string): Promise<Array<any>> {
    try {
      //console.log('checklist');
      //console.log('questionario/' + questionario + '/' +modelo);
      let ResultConn = await this.httpSrv.getChecklist('questionariosaida/' + _questionario + '/' + _modelo, 0, 'Carregando CheckList Saida');
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar o questionariosaida do checklist', error);
    }
  }


  async getQuestionarioOrcamento(_questionario: number, _modelo: string): Promise<Array<any>> {
    try {
      //console.log('checklist');
      //console.log('questionario/' + questionario + '/' +modelo);
      let ResultConn = await this.httpSrv.getChecklist('questionarioorcamento/' + _questionario + '/' + _modelo, 0, 'Carregando CheckList Orçamento');
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar o questionarioorcamento do checklist', error);
    }
  }

  async getQuestionarioOficina(_questionario: number, _modelo: string): Promise<Array<any>> {
    try {
      //console.log('checklist');
      //console.log('questionario/' + questionario + '/' +modelo);
      let ResultConn = await this.httpSrv.getChecklist('questionariooficina/' + _questionario + '/' + _modelo, 0, 'Carregando CheckList Oficina');
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar o questionariooficina do checklist', error);
    }
  }

  async getQuestionarioInspecao(_questionario: number, _modelo: string): Promise<Array<any>> {
    try {
      //console.log('checklist');
      //console.log('questionario/' + questionario + '/' +modelo);
      let ResultConn = await this.httpSrv.getChecklist('questionarioinspecao/' + _questionario + '/' + _modelo, 0, 'Carregando CheckList Inspecao');
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar o questionarioinspecao do checklist', error);
    }
  }

  async getTiposAnexos(_questionario: number, _modelo: string): Promise<Array<any>> {
    try {
      //console.log('checklist');
      //console.log('questionario/' + questionario + '/' +modelo);
      let ResultConn = await this.httpSrv.getChecklist('tipo_anexos/' + _questionario + '/' + _modelo, 0, 'Carregando Tipos de Anexos');
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar o tipo de anexos', error);
    }
  }


  async postQuestionarioCheckList(_api: string, _questionario: number, _checklist: CheckListModel, codigoLogin: string = ""): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.postChecklist(_api + "/" + _questionario + "/cadastro", _checklist, 1, 1, "Enviando as informações...",45000,true,codigoLogin);
      console.log("ResultConn", ResultConn)
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }

  async putQuestionarioCheckList(_api: string, _questionario: number, _checklist: CheckListModel, codigoLogin: string = "", servicos_ofertados: boolean = false): Promise<Array<any>> {
    try {
      // console.log("codigoLogin",codigoLogin)
      if(servicos_ofertados) _checklist.codCheckList = _checklist.codCheckList+"/servicos_ofertados";
      
      let ResultConn = await this.httpSrv.putChecklist(_api + "/" + _questionario + "/" + _checklist.codCheckList, _checklist, 1, 1,"Enviando as informações...",45000,codigoLogin);
      console.log("ResultConn", ResultConn)
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }
  

  async postQuestionarioAnexo(_api: string, _questionario: number, codCheckList: number, _model: AnexoModel, _codConcessionaria:number , mensagem): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.postChecklist(_api + _questionario + "/anexo_2/" + codCheckList + "/" + _codConcessionaria, _model, 0, 1, mensagem);
      console.log("ResultConn ", JSON.stringify(ResultConn))
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o anexo checklist', error);
    }
  }

  async postQuestionarioAnexoAgendamento(_api: string, _questionario: number, agendamento: string, codConcessionaria: number, _model: AnexoModel, mensagem): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.postChecklist(_api + _questionario + "/anexo_3/" + agendamento +"/"+ codConcessionaria, _model, 0, 1, mensagem);
      console.log("ResultConn ", JSON.stringify(ResultConn))
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o anexo checklist', error);
    }
  }

  async postQuestionarioFoto(_api: string, _questionario: number, codCheckList: number, _foto: FotoModel, mensagem): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.postChecklist(_api + "/" + _questionario + "/app_foto_2/" + codCheckList, _foto, 0, 1, mensagem);
      console.log("ResultConn", JSON.stringify(ResultConn))
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }
 // (api, this.questionario, foto, mensagem);
  async deleteMidia(_api: string, codigo: number): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.getChecklist(_api + codigo + '/delete', 0, 'Excluindo Midia');
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao deletar midia', error);
    }
  }

  async postItensFarol(_api: string, _itens: any, mensagem): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.postChecklist(_api, _itens, 0, 1, mensagem);
      console.log("ResultConn", JSON.stringify(ResultConn))
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao salvar os itens do farol', error);
    }
  }
  
  async postQuestionarioVideo(_api: string, _questionario: number, codCheckList: number, _video: VideoModel, mensagem): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.postChecklist(_api + "/" + _questionario + "/app_video_2/" + codCheckList, _video, 0, 1, mensagem,59000);
      console.log("ResultConn", ResultConn)
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }

  async postQuestionarioAudio(_api: string, _questionario: number, codCheckList: number, _audio: AudioModel, mensagem): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.postChecklist(_api + "/" + _questionario + "/audio_2/" + codCheckList, _audio, 0, 1, mensagem,59000);
      console.log("ResultConn", ResultConn)
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }

  async postAgendamento(_codCheckList: number, _codConcessionaria: number, _veiculo: VeiculoModel): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.postChecklist("checklistagendamento/" + _codCheckList + "/" + _codConcessionaria, _veiculo, 0, 0, 'Enviando Agendamento',59000);
      console.log("ResultConn", ResultConn)
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }

  async getAgendamento(_codCheckList: number, _codConcessionaria: number): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.getChecklist("checklistagendamento/" + _codCheckList + "/" + _codConcessionaria, 0, 'Consulta Solicitações Agendamento');
      console.log("ResultConn", ResultConn)
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }

  async postOrcamentoChecklist(_api: string, _questionario: number, codCheckList: number, _model: OrcamentoItemModel, mensagem): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.postChecklist(_api + _questionario + "/orcamento/" + codCheckList, _model, 0, 1, mensagem);
      console.log("ResultConn ", JSON.stringify(ResultConn))
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o anexo checklist', error);
    }
  }

  async getListaAnexos(_api: string, checklist: number, codCheckList: number, mensagem, codAgendamento: string, codConcessionaria: number): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.getChecklist(_api + checklist + '/' + codCheckList+'/'+codAgendamento + '/' + codConcessionaria , 0, 'Carregando Anexos');
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar o anexos do checklist', error);
    }
  }

  async deleteAnexo(_api: string, codAnexo: number, mensagem): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.delete(_api + codAnexo, 1,1, 'Excluindo Anexo');
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar o anexos do checklist', error);
    }
  }


  async getListaChecklist(_codConcessionaria: number, _checklist: number, _nivel: number, _loading: number = 1, _placa:string = null): Promise<Array<CheckListListagemModel>> {
    try {

      let ResultConn;

      ResultConn = await this.httpSrv.getChecklist('checklist/acampa/v2/' + _checklist + '/concessionaria/' + _codConcessionaria + '/' + _nivel + (_placa?'/' + _placa:''), _loading);

      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <Array<CheckListListagemModel>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar as listagem checklist', error);
    }
  }

  async getMapaChecklist(_codConcessionaria: number, _checklist: number): Promise<Array<CheckListListagemModel>> {
    try {

      let ResultConn;

      ResultConn = await this.httpSrv.getChecklist(ConfigHelper.ApiCheckListV1 + _checklist + '/concessionaria/' + _codConcessionaria + '/(d.nivel<>0)');

      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <Array<CheckListListagemModel>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar as listagem checklist', error);
    }
  }

  async getListaChecklistFinalizados(_codConcessionaria: number, _checklist: number): Promise<Array<CheckListListagemModel>> {
    try {

      let ResultConn;

      ResultConn = await this.httpSrv.getChecklist('checklist/acampa/v2/' + _checklist + '/concessionaria/' + _codConcessionaria + '/(d.nivel=0)');

      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <Array<CheckListListagemModel>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar as listagem checklist', error);
    }
  }

  async getCheckList(_checklist: number, _codchecklist: number): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.getChecklist(ConfigHelper.ApiCheckListV1 + _checklist + "/" + _codchecklist);
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao buscar o checklist', error);
    }
  }


  async postAtualizarDados(_api: string, _concessionaria: number, _dados: any): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.postChecklist(_api + "/" + _concessionaria, _dados, 1, 1);
      console.log("ResultConn", ResultConn)
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }

  async postListaAssinaturas(_api: string, _dados: any): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.post(_api, _dados, 0, 1);
      console.log("ResultConn", ResultConn)
      if (ResultConn.success) {
        return <any>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }

  async postSalvarAssinatura(_api: string, _dados: any): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.post(_api, _dados, 0, 1);
      console.log("ResultConn", ResultConn)
      if (ResultConn.success) {
        return <any>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }


  async getFormulario(_checklist: number, _codChecklist: number): Promise<Array<any>> {
    try {

      let ResultConn;

      ResultConn = await this.httpSrv.getChecklist('consulta_formularios_nivel/' + _checklist + '/' + _codChecklist, 0);

      // console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar as listagem checklist', error);
    }
  }

  async postFormularioCheckList(_api: string, _codFormulario: number, _codConcessionaria: number, _codChecklist: number, _formulario: any): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.postChecklist(_api + "/" + _codFormulario + "/" + _codConcessionaria + "/" + _codChecklist, _formulario, 1, 1);
      console.log("ResultConn", ResultConn)
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }


  async deleteCheckList(_checklist: number, _codchecklist: number, codigoLogin: string = ""): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.delete(ConfigHelper.ApiCheckListV1 + _checklist + "/" +  _codchecklist, 1, 1,codigoLogin);
      console.log("ResultConn",ResultConn)
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao deletar o checklist', error);
    }
  }

  async deleteFormulario(_codChecklist: number,_codFormulario: number, codigoLogin: string = "", _codConcessionaria:number): Promise<Array<any>> {
    try {
      console.log("ConfigHelper.ApiCheckListV1 + _codFormulario + +  _codChecklist", ConfigHelper.ApiCheckListV1+ "formulario/" + _codFormulario + "/" +  _codChecklist)
      let ResultConn = await this.httpSrv.deleteFormulario('delete_formulario/' + _codFormulario + "/" +  _codChecklist + "/" +  _codConcessionaria, 1, 1,codigoLogin);

    
      console.log("ResultConn",ResultConn)
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao deletar o checklist', error);
    }
  }

  async postChecklistAgendamento(_api: string,_registro: VeiculoModel): Promise<Blob>{
    try {
      let ResultConn = await this.httpSrv.postChecklistAgendamento(_api + "imprimir_agendamento.php", _registro, 0, 1,"Enviando as informações...",45000, false);
      console.log("ResultConn", ResultConn)
      if (ResultConn.success) {
        return <Blob>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao baixar o pdf', error);
    }
  }


  async getDdiPaises(): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.getLocal('assets/data/ddipaises.json');
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar os ddi dos paises', error);
    }
  }

  async getListaChecklistStellantis(_chassi:string, _codConcessionaria: number, _checklist: number, _nivel: number, _loading: number = 1): Promise<Array<CheckListListagemModel>> {
    try {

      let ResultConn;

      ResultConn = await this.httpSrv.getChecklistStellantis('checklist/acampa/v2/' + _checklist + '/concessionaria/' + _codConcessionaria + '/chassi/'+ _chassi+'/'+ _nivel, _loading);

      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <Array<CheckListListagemModel>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar as listagem checklist', error);
    }
  }

  async getMidiasCheckList(_checklist: number, _codchecklist: number): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.getChecklist('checklist/midias_checklist/v1/' + _checklist + "/" + _codchecklist);
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao buscar as midias do checklist', error);
    }
  }

    async postLogChecklist(_api: string, _questionario: number, _codChecklist: number, _dados: any, codigoLogin: string = "",  _idagendamento: number =0): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.postLogChecklist(_api + "/" + _questionario + "/" + _codChecklist + "/" + _idagendamento, _dados, 1, 1, "Enviando as informações...",45000,codigoLogin);
      console.log("ResultConn", ResultConn)
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o checklist', error);
    }
  }

  async getSintomasMCS(_text: string,_checklist: number=193, _perPage:number = 30, loading: number = 1): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.getChecklist('parceiros/sintomas/?query='+_text+'&checklist='+_checklist+'&perPage='+_perPage, loading, "Carregando sintomas MCS...");
      if (ResultConn.data) {
        return <any>ResultConn.data;
      }
    } catch (error) {
      console.log('Problema ao buscar Sintomas MCS ', error);
    }
  }

  async getFormularioOficinaDigitalItens(_checklist: number, _codCheckList:number): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.getChecklist('formulario/oficina_digital_itens/'+_checklist+'/'+_codCheckList);
      if (ResultConn.success) {
        return <any>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao buscar os itens de formulario com oficina digital do checklist', error);
    }
  }


  async getContextoMCS(_symptomId: string): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.getChecklist('parceiros/sintomas/contexto/?symptomId='+_symptomId, 1, "Carregando contextos MCS...");
      if (ResultConn.data) {
        return <any>ResultConn.data;
      }
    } catch (error) {
      console.log('Problema ao buscar Contextos MCS', error);
    }
  }

  async postSintomasMCS(_data: any): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.postChecklist('parceiros/sintomas', _data,1, 1, "Salvando sintomas MCS..." );
      if (ResultConn.data) {
        return <any>ResultConn.data;
      }
    } catch (error) {
      console.log('Problema ao buscar Sintomas MCS ', error);
    }
  }

  async getSintomasCadastrados(_chassi: string, loading: number =1, _data: Date = new Date(),): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.getChecklist('parceiros/sintomas/baskets?vin='+_chassi, loading, "Carregando ...");
      if (ResultConn.data) {
        return <any>ResultConn.data;
      }
    } catch (error) {
      console.log('Problema ao buscar Sintomas MCS ', error);
    }
  }

  async consultarOTS(chassi: string, loading: number = 1): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.getChecklist('parceiros/consultar-ots?chassi='+chassi,loading,"Buscando OTS...",null,31000);
      if (ResultConn.success) {
        return <any>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao consultar recall', error);
    }
  }

async consultarBlueCareHyundai(chassi: string, loading: number = 1): Promise<any> {
  try {
    let ResultConn = await this.httpSrv.getChecklist('parceiros/check-blue-care-hyundai?chassi='+chassi,loading,"Buscando My Hyundai Care...",null,31000); 
    if (ResultConn.success) {
      return <any>ResultConn.data;
    }
  } catch (error) {
    console.log('problema ao consultar My Hyundai Care', error);
  }
}

async consultarRecall(chassi: string, loading: number = 1): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.getChecklist('parceiros/recall?chassi='+chassi,loading,"Buscando Recall...",null,31000);
      if (ResultConn.success) {
        return <any>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao consultar recall', error);
    }
  }

  async consultarRecallGeral(form: any, loading: number = 1): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.postDmsCamp('consultarecall',form,loading,"Buscando Recall...",true,2,31000);
      if (ResultConn.success) {
        return <any>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao consultar recall', error);
    }
  }
  
  async getConectividadeStellantis(_chassi: string, loading: number = 1): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.getChecklist('parceiros/conectividade-stellantis?chassi='+_chassi, loading, "Carregando informações de serviços de conectividade...");
      if (ResultConn.success && ResultConn.data && ResultConn.data.data) {
        console.log("ResultConn",ResultConn)
        return <any>ResultConn.data.data;
      }
    } catch (error) {
      console.log('Problema ao buscar Sintomas MCS ', error);
    }
  }

  async atualizarOfic(_checklist: number, _codChecklist: number, loading: number = 1): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.getChecklist('atualizar_ofic/' + _checklist + '/' + _codChecklist, loading, 'Atualizando OFIC...');
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao atualizar OFIC', error);
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/checklist/checklist.ts